// brPlugin.js
export default function (md) {
  function brInline(state, silent) {
    const pos = state.pos;
    if (state.src.slice(pos, pos + 4) !== "<br>" && state.src.slice(pos, pos + 5) !== "<br/>" && state.src.slice(pos, pos + 4) !== "[br]") return false;
    if (silent) return true;

    // hardbreak token -> RN kann daraus \n machen
    state.push("hardbreak", "br", 0);
    state.pos += state.src.slice(pos, pos + 5) === "<br/>" ? 5 : state.src.slice(pos, pos + 4) === "<br>" ? 4 : 4;
    return true;
  }

  md.inline.ruler.before("emphasis", "br_inline", brInline);
}
